<div *ngIf="permissionAccess">

  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-end mb-4 border-bottom pb-4 ml-1">
    <div class="mb-3 mb-md-0">
      <h2 class="fw-semibold text-dark mb-1">External Responses And Requests</h2>
      <p class="text-secondary mb-0">Registro de respuestas y solicitudes externas centralizado</p>
    </div>
  </div>

  <form action="" [formGroup]="range">
    <div class="row" style="margin-top: 2.5rem;">
      <div class="col-lg-4">
        <mat-form-field>
          <mat-label>Selecciona una rango de fechas</mat-label>
          <mat-date-range-input [rangePicker]="picker" required>
            <input matStartDate formControlName="start" placeholder="Start date" />
            <input matEndDate formControlName="end" placeholder="End date" />
          </mat-date-range-input>

          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field>
          <mat-label>Tipo de entrada</mat-label>
          <mat-select formControlName="type" required>
            <mat-option *ngFor="let type of types" [value]="type.status" (click)="setType(type.status)" selected>
              {{type.typ}}: {{type.status}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field>
          <mat-label>Partner</mat-label>
          <mat-select formControlName="partner" required>
            <mat-option *ngFor="let partner of partners" [value]="partner.id">
              {{partner.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-3">
        <button type="submit" mat-raised-button color="primary" class="ml-2 mt-2" (click)="getInfo()">Mostrar</button>
      </div>
    </div>
  </form>

  <div *ngIf="error">
    <mat-card>{{error}}</mat-card>
  </div>
  <div class="row mt-5" *ngIf="theresData">
    <div class="col-lg-12">
      <mat-accordion *ngFor="let data of theresData">
        <mat-expansion-panel class="mt-5" hideToggle>
          <mat-expansion-panel-header [ngClass]="{'badRequest': data.status == '404' || data.status == '400'}">
            <mat-panel-title>
              <p>Url: {{data.url}}</p>
              <p class="ml-5">Status: {{data.status}}</p>
              <p class="ml-5">Fecha: {{data.date}}</p>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>Response: {{data.response}}</p> <br>
          <div style="overflow-wrap:break-word">
            <p>Body: {{data.body}}</p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<app-restricted-module-view *ngIf="!permissionAccess"></app-restricted-module-view>